const filterVisible = contractPlans => {
  return contractPlans.filter(
    contractPlan =>
      contractPlan.status === 'active' || contractPlan.status === 'finished',
  )
}

export default filterVisible
